export const internationalLanguages = ["ru", "es", "fr"] as const;
export type InternationalLanguage = (typeof internationalLanguages)[number];
export type MarketingLanguage = "en" | "zh" | "ja" | InternationalLanguage;

export const marketingLanguageOptions: { code: MarketingLanguage; label: string; shortLabel: string }[] = [
  { code: "en", label: "English", shortLabel: "EN" },
  { code: "zh", label: "中文", shortLabel: "中文" },
  { code: "ja", label: "日本語", shortLabel: "日本語" },
  { code: "es", label: "Español", shortLabel: "ES" },
  { code: "fr", label: "Français", shortLabel: "FR" },
  { code: "ru", label: "Русский", shortLabel: "RU" },
];

export const isInternationalLanguage = (language: string): language is InternationalLanguage =>
  internationalLanguages.includes(language as InternationalLanguage);

export const marketingSection = (pathname: string): "business" | "product" | "learnflow" | "home" => {
  const segments = pathname.split("/").filter(Boolean);
  const section = isInternationalLanguage(segments[0]) ? segments[1] : segments[0];
  return section === "business" || section === "product" || section === "learnflow" ? section : "home";
};

export const marketingLanguageHref = (language: MarketingLanguage, pathname: string): string => {
  const section = marketingSection(pathname);
  if (isInternationalLanguage(language)) return `/${language}${section === "home" ? "" : `/${section}`}`;
  return section === "home" ? "/" : `/${section}`;
};
